import { useCallback } from "react";
import { getSettingsOrgResourceSearchFilters } from "../helpers/settings";
import { useCompanyPreferences } from "../../features/Settings/Configuration/hooks/usePreferences";

const ORG_LEVEL_FIELDS = ["id", "code", "description", "glSegment", "orgLevelGroup", "status"];
const ACTIVE_AND_INACTIVE = ["active", "inactive"];

// Org level filters in reports list inactive levels too when the company opts in.
export const useReportOrgLevelSearchFilters = () => {
	const includeInactive = Boolean(useCompanyPreferences("reports.filters.includeInactiveOrgLevels"));

	return useCallback((search) => {
		if (!includeInactive) {
			return getSettingsOrgResourceSearchFilters(search);
		}
		return {
			...getSettingsOrgResourceSearchFilters(search, ORG_LEVEL_FIELDS),
			status: ACTIVE_AND_INACTIVE,
		};
	}, [includeInactive]);
};
